import { Card } from "@components/cards/card";
import { IconType } from "react-icons";

interface IProps {
  title: string;
  value: string;
  subtitle: string;
  icon: IconType;
  variant: "primary" | "success" | "warning" | "danger" | "info" | "secondary";
}

const iconTextMap = {
  primary: "text-white",
  success: "text-white",
  warning: "text-dark",
  danger: "text-white",
  info: "text-dark",
  secondary: "text-white",
};

export function InfrastructureSummaryCard({
  title,
  value,
  subtitle,
  icon: Icon,
  variant,
}: IProps) {
  return (
    <Card className={`h-100 shadow-sm border border-${variant} border-opacity-25`}>
      <div className="card-body p-4">
        <div className="d-flex align-items-center gap-3">
          <div
            className={`bg-${variant} ${iconTextMap[variant]} rounded p-3 flex-shrink-0`}
          >
            <Icon size={24} />
          </div>
          <div>
            <p className="fw-semibold mb-2 text-dark">{title}</p>
            <h2 className="fw-bold mb-1">{value}</h2>
            <small className="text-muted">{subtitle}</small>
          </div>
        </div>
      </div>
    </Card>
  );
}
